<template>
	<div class="detail" v-if="detail" @click="showService = false">
		<div class="detail-title">
			{{ detail.title }}
			<el-tooltip class="item" effect="dark" content="项目由数字像素官方认证" placement="top">
				<div class="detail-exclusive">官方认证</div>
			</el-tooltip>

		</div>
		<div class="detail-con">
			<el-card class="company-content-card main-detail" shadow="never">
				<div class="detail-wrap">
					<!-- <div class="detail-head"> -->
						<!-- <div class="detail-head__title"> -->
							<!-- <span>{{ detail.title }}</span> -->
							<!-- <div class="mode"> 
						<span :class="modeDeep ? '' : 'active'" @click="handleChangeMode"><img src="@/assets/images/sun.png" alt=""></span>
						<span :class="modeDeep ? 'active' : ''" @click="handleChangeMode"><img src="@/assets/images/moon.png" alt=""></span>
					</div> -->
						<!-- </div> -->
						<!-- <div class="detail-head__extra">
					<div class="tag">
						<span class="tag-item" v-for="item in detail.classList" :key="item.id">
							#{{ item.name }}
						</span>
					</div>
					<div class="time">
					<i class="el-icon-aim"></i>&nbsp;&nbsp;{{ detail.createTime | getTime }}
					</div>
				</div> -->
					<!-- </div> -->
					<div class="detail-content" ref="detailWrap">
						<!-- <div v-if="detail.introduction">
							<div class="detail-content-title">项目简介</div>
							<div v-html="detail.introduction"></div>
						</div> -->
						<div v-if="detail.fileList && detail.fileList.length">
							<!-- <div class="detail-content-title">视频动画</div> -->
							<div
								class="detail-content-mainFile"
								v-for="file in detail.fileList"
							>
								<video
									v-if="file.type"
									:src="file.url"
									controls="controls"
									controlsList="nodownload"
								></video>
								<img v-else v-lazy="file.url" />
							</div>
						</div>
						<div v-if="detail.content">
							<!-- <div class="detail-content-title">详细资料</div> -->
							<div v-html="detail.content"></div>
							<div
								class="no-pay-wrap"
								v-if="detail.classType === 2 && !detail.paid"
							>
								试读已结束，购买后下载该方案
								<span class="buy-btn" @click="toPay">立即购买</span>
							</div>
						</div>
					</div>
				</div>
			</el-card>
			<div style="width: 385px">
				<el-card
					class="company-content-card company-info"
					shadow="never"
					v-if="detail.id"
				>
					<!-- <div class="company-info-name">{{ detail.title }}</div> -->
					<!-- <div class="company-info-prove">
						<img src="/static/images/user.png" alt="" />
						官方认证
					</div> -->
					<div class="detail-wrap">
						<div class="detail-item">
							<span class="item-label">编号：</span>
							<span class="item-value">{{detail.serialCode}}</span>
						</div>
						<div class="detail-item">
							<span class="item-label">分类：</span>
							<span class="item-value">{{(detail.classList || []).map(item => item.name).join('/')}}</span>
						</div>
						<div class="detail-item">
							<span class="item-label">上传时间：</span>
							<span class="item-value">{{detail.createTime.split(' ')[0]}}</span>
						</div>
					</div>
					<!-- <div class="company-info-addition">
						<span class="company-info-price-tag needPay">付费</span>
						<template v-if="detail.classType === 2">
							<span class="company-info-price-tag price"
								>￥{{ extendInfo.price }}</span
							>
							<span class="company-info-price-tag origin-price"
								>￥{{ extendInfo.scribingPrice }}</span
							>
						</template>
						<template v-if="detail.classType === 1">
							<span class="price">价格需咨询</span>
						</template>
					</div> -->
					<!-- <div
						class="company-info-project"
						v-if="detail.classType === 3 && extendInfo.projectItems.length"
					>
						<div class="company-info-project-tit">项目列表</div>
						<el-radio-group
							class="company-info-project-radio"
							v-model="selectItemIndex"
						>
							<el-radio
								:label="index"
								v-for="(project, index) in extendInfo.projectItems"
								v-if="payUrl ? projectItem.id === project.id : true"
								:key="project.title"
							>
								<div class="company-info-project-item" :key="project.title">
									<div>
										{{ project.title }}
									</div>
									<span>{{ project.describeInfo }}</span>
								</div>
							</el-radio>
						</el-radio-group>
					</div> -->
					<template v-if="!payUrl && !showPayWay">
						<!-- <div class="company-info-detail" v-if="extendInfo.describeInfo">
							<div class="company-info-detail-desc">
								{{ extendInfo.describeInfo }}
							</div>
						</div> -->
						<!-- <div v-if="!projectItem.paid && projectItem.type === 1 && projectItem.price != 0">
							<el-button
								class="show-url-btn"
								type="primary"
								block
								@click="toShowUrl"
								v-if="detail.showStatus == 0"
							>
								<span style="vertical-align: top">在线演示</span>
							</el-button>
							<el-button
								class="pay-btn"
								type="primary"
								block
								@click="handleShowPay"
							>
								<span style="vertical-align: top">立即购买</span>
							</el-button>
							<div class="ques-contract">
								<img
									v-show="agreeContract"
									src="../../assets/images/choose.png"
									alt=""
									@click="agreeContract = !agreeContract"
								/>
								<img
									v-show="!agreeContract"
									src="../../assets/images/un-choose.png"
									alt=""
									@click="agreeContract = !agreeContract"
								/>
								阅读并接受<router-link
									as="span"
									class="contract"
									to="/blackboard/buyTreaty"
									target="_blank"
									>《在线购买协议》</router-link
								>
							</div>
							<div class="ques-text">
								其他支付方式及发票开具请联系助手微信 shuzixs01
								支付后如未跳转，请刷新当前页面
							</div>
						</div> -->
						<div>
							<el-button
								class="show-url-btn"
								type="primary"
								block
								@click="toShowUrl"
								v-if="detail.showStatus == 0"
							>
								<span style="vertical-align: top">在线演示</span>
							</el-button>
							<el-button
								class="pay-btn"
								type="primary"
								block
								@click.stop="showService = true"
							>
								<span style="vertical-align: top">立即咨询</span>
								<div class="service-modal" v-show="showService">
									<img src="/static/images/wechat-service.png" alt="" />
									<div>
										<div class="service-modal-tit">
											您好，我是您的专属客服
										</div>
										<div class="service-modal-info">
											咨询项目定制开发相关问题，请添加企业微信，我将及时为你服务
										</div>
									</div>
								</div>
							</el-button>
						</div>
						<!-- <el-button
							v-if="projectItem.paid || projectItem.price == 0"
							class="download-btn"
							:loading="isDownLoading"
							type="primary"
							@click="handleDownLoad"
						>
							<img
								src="@/assets/images/download.png"
								alt="下载"
								class="download-btn-img"
							/><span style="vertical-align: top">&nbsp;立即下载</span>
						</el-button> -->
					</template>
					<!-- <div
						class="company-info-detail-payWay"
						v-if="showPayWay && !payUrl && !projectItem.paid"
					>
						<div class="pay-tit">请选择支付方式</div>
						<div class="pay-con">
							<div class="pay-item" @click="handleClickPay('wechat')">
								<img
									src="../../assets/images/wechat_pay.png"
									class="pay-icon"
									alt=""
								/>
								<div>微信支付</div>
							</div>
							<div class="pay-item" @click="handleClickPay('alipay')">
								<img
									src="../../assets/images/ali_pay.png"
									class="pay-icon"
									alt=""
								/>
								<div>支付宝支付</div>
							</div>
						</div>
						<div class="pay-tip">
							其他支付方式及发票开具请联系助手微信 shuzixs01 <br />
							支付后如未跳转，请刷新当前页面
						</div>
					</div>
					<template v-if="payUrl">
						<div class="pay-content">
							<div class="pay-tips" v-if="payType === 'wechat'">
								<img
									src="@/assets/images/wx-pay.png"
									alt="weixinpay"
									width="36"
								/>
								<span>请使用微信支付</span>
							</div>
							<div class="pay-tips ali" v-if="payType === 'alipay'">
								<img src="@/assets/images/ali.png" alt="weixinpay" width="36" />
								<span>请使用支付宝支付</span>
							</div>
							<img v-lazy="payUrl" class="company-image" />
							<div class="more-pay-way" @click="payUrl = ''">更多支付方式</div>
						</div>
					</template> -->
				</el-card>
			</div>
		</div>


		<!-- <div v-if="QRcode" class="detail-extra">
        <el-button type="primary" class="form-button" @click="purposeRequest">→&nbsp;&nbsp;&nbsp;我要同款</el-button>
        <div class="projectCase-contact">
          <div>联系我们</div>
          <img :src="QRcode" alt="">
        </div>
      </div> -->
		<RequestForm
			v-if="showRequestForm"
			:showRequestForm.sync="showRequestForm"
			:projectInfo="detail"
		/>
		<img-dialog-show
			:img-dialog-show.sync="imgDialogShow"
			:img-url-arr="pictureList"
			:img-index="index"
		/>
	</div>
</template>

<script>
import moment from "moment";
import RequestForm from "./components/RequestForm";
import { getFootByType } from "@/api/blackboard";
import { getPayUrl, getStatus } from "@/api/order";
import { getServiceDetail, downloadProjectCase, projectItemDownload } from "@/api/projectCase";
import { virtualDownLoad } from "@/utils/utils";
import ImgDialogShow from "@/components/ImgDialogShow";
import AliOSS from "ali-oss";
import { getOSSConfig } from "@/api/common";
export default {
	name: "ProjectCaseDetail",
	components: {
		RequestForm,
		ImgDialogShow,
	},
	inject: ["checkToken", "reload", "backTop"],
	data: () => ({
		detail: null, //项目案例详情
		// modeDeep: false, // 是否深色模式显示
		showRequestForm: false, // 是否展示同款需求弹出框
		QRcode: null,
		agreeContract: true,
		// 是否正在下载
		isDownLoading: false,
		payUrl: null,
		payType: "",
		extendInfo: {},
		showService: false,
		showPayWay: false,
		imgDialogShow: false,
		index: 0,
		pictureList: [],
		selectItemIndex: 0,
		fileIndex: "", // 当前显示文件的索引值
		// rightIndex: 0, // 文件列表当前显示的最后一个的索引值
		// perLineFileNum: 6, // 一行文件显示个数
		// perMoveNum: 3, // 一次移动个数
	}),
	filters: {
		getTime(time) {
			return moment(time).format("YYYY-MM-DD");
		},
	},
	watch: {
		selectItemIndex() {
			this.showPayWay = false;
		},
	},
	computed: {
		projectItem() {
			if (this.extendInfo.projectItems && this.extendInfo.projectItems.length) {
				return this.extendInfo.projectItems[this.selectItemIndex];
			} else {
				return {}
			}
			
		},
	},
	mounted() {
		this.getServiceDetail();
		// this.getFootByType();
	},
	methods: {
		handleImage(i) {
			this.imgDialogShow = true;
			this.index = i;
		},
		bindImage() {
			const imgEl = [...this.$refs.detailWrap.getElementsByTagName("img")];
			this.pictureList = imgEl.map(item => {
				return {
					address: item.src,
				};
			});
			imgEl.forEach((item, index) => {
				item.addEventListener("click", () => {
					this.handleImage(index);
				});
			});
		},
		/**
		 * 点击左翻
		 */
		handleClickLeft() {
			if (this.fileIndex === 0) {
				this.$message.warning("不能再往左翻了哦~");
				return;
			}
			this.fileIndex--;
		},
		/**
		 * 点击右翻
		 */
		handleClickRight() {
			if (this.fileIndex === this.detail.fileList.length - 1) {
				this.$message.warning("不能再往右翻了哦~");
				return;
			}
			this.fileIndex++;
		},
		/**
		 * 点击我要同款
		 */
		purposeRequest() {
			this.showRequestForm = true;
		},
		/**
		 * 获取项目案例详情
		 */
		getServiceDetail() {
			getServiceDetail(this.$route.params.id).then(({ data }) => {
				this.detail = data;
				window.document.title = this.detail.title
				this.detail.paid = data.paid === 1;
				// data.extend.projectItems = [
				// 		{
				// 			id: 3,
				// 			projectId: 118,
				// 			classType: 3,
				// 			type: 0,
				// 			title: "asdf",
				// 			describeInfo: "asdf",
				// 			price: null,
				// 			source: "665b/jpeg/665b7e9a0e923cc91ce46479f9b755d0.jpeg",
				// 			scribingPrice: null,
				// 			createdTime: "2022-07-21 01:30:51",
				// 			updatedTime: "2022-07-21 01:30:51",
				// 		},
				// 		{
				// 			id: 4,
				// 			projectId: 118,
				// 			classType: 3,
				// 			type: 1,
				// 			title: "rrr",
				// 			describeInfo: "erer",
				// 			price: 12,
				// 			paid:1,
				// 			source: "f9eb/jpg/f9ebe5ff24805eeb458b5671f5d8be27.jpg",
				// 			scribingPrice: 33,
				// 			createdTime: "2022-07-21 14:25:56",
				// 			updatedTime: "2022-07-21 14:25:56",
				// 		},
				// 		{
				// 			id: 8,
				// 			projectId: 118,
				// 			classType: 3,
				// 			type: 1,
				// 			title: "买一个吧",
				// 			describeInfo: "erer",
				// 			price: 12,
				// 			paid:0,
				// 			source: "f9eb/jpg/f9ebe5ff24805eeb458b5671f5d8be27.jpg",
				// 			scribingPrice: 33,
				// 			createdTime: "2022-07-21 14:25:56",
				// 			updatedTime: "2022-07-21 14:25:56",
				// 		},
				// 		{
				// 			id: 5,
				// 			projectId: 118,
				// 			classType: 3,
				// 			type: 0,
				// 			title: "234",
				// 			describeInfo: "33",
				// 			price: null,
				// 			source: null,
				// 			scribingPrice: null,
				// 			createdTime: "2022-07-21 14:25:56",
				// 			updatedTime: "2022-07-21 14:25:56",
				// 		},
				// 	],
				(data.extend.projectItems || []).forEach(item => {
					item.paid = item.paid === 1
				})
				this.extendInfo = {
					...data.extend,
					projectItems: data.extend.projectItems || [],
				};
				this.getBuffer();
				this.$nextTick(() => {
					this.bindImage();
					this.$refs.detailWrap &&
						(this.$refs.detailWrap.oncontextmenu = () => false);
				});
				// this.rightIndex = Math.min(this.detail.fileList.length, this.perLineFileNum);
			});
		},
		/**
		 * 改变显示模式
		 */

		async getBuffer() {
			let config = await getOSSConfig();
			var client = new AliOSS({
				region: "oss-cn-chengdu",
				accessKeyId: config.data.accessid,
				accessKeySecret: "fEenefEpkSzxjT3wsIidFDHRHdslq9",
				bucket: 'shuzixs1',
				policy: config.data.policy,
				signature: config.data.signature,
				secure: true,
			});
			for (let i = 0; i < this.detail.fileList.length; i++) {
				if (!this.detail.fileList[i].url.startsWith("http")) {
					let url = await client.signatureUrl(this.detail.fileList[i].url);

					this.$set(this.detail.fileList, i, {
						type: this.detail.fileList[i].type,
						url,
					});
				}
			}
			this.fileIndex = 0;
		},
		getFootByType() {
			getFootByType({ type: 5 }).then(({ data }) => {
				this.QRcode = data;
			});
		},

		// 点击下载
		handleDownLoad() {
			if (this.isDownLoading) {
				// this.$message.warning('正在下载哦，不要心急');
				return;
			}
			this.isDownLoading = true;
			projectItemDownload(this.projectItem.id)
				.then(res => {
					this.isDownLoading = false;
					virtualDownLoad(res.data, this.projectItem.title);
				})
				.catch(() => {
					this.isDownLoading = false;
				});
		},

		handleShowPay() {
			if (!this.agreeContract) {
				this.$message.warning("请勾选阅读并接受《在线购买协议》");
				return;
			}
			this.showPayWay = true;
		},
		toShowUrl() {
			window.open(this.detail.showUrl, "_blank")
		},
		toPay() {
			this.showPayWay = true;
			this.backTop();
		},
		// 点击购买
		handleClickPay(payType) {
			this.payType = payType;
			getPayUrl({ type: 2, goodsId: this.projectItem.id, payType })
				.then(res => {
					this.payUrl = res.data.data;
					this.getPayResult(res.data.orderId);
				})
				.catch(() => {
					this.payUrl = "";
				});
		},
		getPayResult(id) {
			getStatus(id).then(res => {
				const { data } = res;
				const projectIndex = this.extendInfo.projectItems.findIndex(item => item.id === this.projectItem.id)
				if (data.code === 1) {
					this.payUrl = "";
					this.extendInfo.projectItems[projectIndex].paid = true;
					this.showPayWay = false;
				} else if (data.code === 2) {
					setTimeout(() => {
						this.getPayResult(id);
					}, 2e3);
				} else if (data.code === 3) {
					this.payUrl = "";
					this.extendInfo.projectItems[projectIndex].paid = true;
					this.showPayWay = false;
				} else {
					this.payUrl = "";
					this.showPayWay = false;
					this.$message.error("付款失败，" + data.msg);
				}
			});
		},
	},
};
</script>
<style lang="scss">
.detail-content {
	* {
		max-width: 100%;
	}
	pre {
		white-space: pre-wrap;
		word-wrap: break-word;
	}
}
</style>
<style lang="scss" scoped>
.detail {
	width: 100%;
	.detail-title {
		width: 1285px;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: 20px;
			color: #000000;
			padding: 40px 0 24px;
			margin: 0 auto;
			box-sizing: border-box;
			.detail-exclusive {
				margin-left: 16px;
				padding: 2px 10px;
				border-radius: 4px 4px 4px 4px;
				border: 1px solid #000000;
				font-weight: 400;
				font-size: 12px;
				color: #000000;
				cursor: pointer;
			}
		}
		.detail-con{
			
	overflow-y: auto;
	display: flex;
	justify-content: center;
	position: relative;
	// padding-top: 20px;
		}
	.company-content-card {
		border: 0;
	}
	.main-detail {
		// flex: 1;
		margin-right: 20px;
		min-width: 840px;
		border-radius: 10px;
		/deep/ .el-card__body {
			.detail-wrap {
				margin: 0 auto;
				border-radius: 10px;
				background-color: #fff;
				width: 840px;
			}
			.detail-head {
				padding: 0 0 10px 0;
				// border-bottom: 1px solid #ecedff;
				&__title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					color: #272c40;
					font-size: 22px;
					font-weight: 600;
				}

				&__extra {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.tag {
						margin: 10px 0;
						&-item {
							margin: 10px 10px 0 0;
							padding: 3px 10px;
							background: rgba(47, 84, 235, 0.1);
							border-radius: 12px;
							font-size: 12px;
							color: #2f54eb;
							cursor: pointer;
						}
					}
					.time {
						font-size: 14px;
						color: #a8adc1;
					}
				}
			}
			.detail-content {
				// padding: 20px 100px;
				position: relative;
				img,
				video {
					max-width: 100%;
					max-height: 100%;
				}
				img {
					cursor: pointer;
				}
				&-title {
					padding: 20px 0;
					@include font(#333, 18px, 600);
				}
				.no-pay-wrap {
					width: 100%;
					height: 608px;
					background: linear-gradient(
						180deg,
						rgba(255, 255, 255, 0) 43%,
						#ffffff 61%
					);
					position: absolute;
					bottom: 0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-end;
					padding-bottom: 120px;
					color: #595959;
					font-size: 20px;
					.buy-btn {
						display: inline-block;
						width: 179px;
						height: 56px;
						background: #eb793c;
						border-radius: 4px 4px 4px 4px;
						cursor: pointer;
						color: #fff;
						font-size: 20px;
						text-align: center;
						line-height: 56px;
						// font-weight: 600;
						margin-top: 16px;
					}
				}
				&-mainFile {
					width: 100%;
					// height: 600px;
					text-align: center;
					img,
					video {
						max-width: 100%;
						height: 100%;
					}
				}
				&-file {
					position: relative;
					margin-top: 30px;
					&-wrap {
						width: 100%;
						overflow: hidden;
						white-space: nowrap;
						&-fit {
							position: relative;
						}
					}
					&-item {
						display: inline-block;
						box-sizing: border-box;
						margin-right: 15px;
						border-radius: 4px;
						width: 182px;
						height: 100px;
						vertical-align: middle;
						text-align: center;
						&.current {
							border: 2px solid #5678ff;
						}
					}
					[class*="el-icon-"] {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						padding: 10px;
						border-radius: 50%;
						background-color: rgba(124, 124, 124, 0.7);
						font-size: 20px;
						color: #fff;
						cursor: pointer;
						&:hover {
							opacity: 0.9;
						}
						&.disabled {
							opacity: 0.3;
						}
					}
					.el-icon-arrow-left {
						left: -60px;
					}
					.el-icon-arrow-right {
						right: -60px;
					}
				}
			}
		}
	}

	.company-info {
		min-width: 300px;
		// min-height: 650px;
		width: 385px;
		vertical-align: top;
		text-align: left;
		background: inherit;
		overflow: visible;

		// margin-right: 140px;
		& /deep/ .el-card {
		}

		& /deep/ .el-card__body {
			text-align: left;
			background: #fff;
			padding: 24px 20px 30px 24px;
			border-radius: 10px;

			.company-info-name {
				font-size: 20px;
				font-weight: 600;
			}
			.company-info-prove {
				overflow: hidden;
				display: flex;
				align-items: center;
				flex: 1;
				margin: 0 0 20px 0;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 12px;
				color: #3a3e50;
				img {
					width: 20px;
					height: 20px;
					border-radius: 100%;
					margin-right: 5px;
				}
			}
			.detail-wrap {
				margin-bottom: 20px;
			}
			.detail-item {
				margin-bottom: 10px;
				font-size: 14px;
				.item-label {
					color: #999999;
					line-height: 19px;
					
				}
				.item-value {
					color: #333
				}
			}
			.company-info-project {
				&-tit {
					color: #999999;
					font-size: 14px;
					margin-bottom: 12px;
				}
				&-radio {
					display: flex;
					flex-direction: column;
					overflow: hidden;
					.el-radio {
						display: flex !important;
						// align-items: center;
						margin-right: 0;
						margin-bottom: 6px;
						line-height: 20px;
						overflow: hidden;
						padding: 7px 10px;
						//添加边框
						/* border: 1px solid rgb(207, 204, 204); */
						//选中时边框的颜色
						/* &.is-checked {
								border: 1px solid #28d4c1 !important;
							} */
						//鼠标滑过改变字体和小圆圈边框的样式
						&:hover {
							border-color: #eb793c !important;
							color: #eb793c !important;
							background-color: #fef2e8;
							border-radius: 4px;
							//鼠标滑过时小圆点边框显示
							.el-radio__inner {
								border-color: #eb793c;
							}
						}
						.el-radio__label {
							flex: 1;
							overflow: hidden;
						}
						&.is-checked {
							.el-radio__label {
								.company-info-project-item div {
									color: #eb793c;
								}
							}
						}

						.el-radio__input {
							margin-top: 3px;
							//选中时的样式
							&.is-checked {
								.el-radio__inner {
									//选中时小圆圈的的颜色
									background-color: #fff;
									border-color: #eb793c;
									&::after {
										width: 7px;
										height: 7px;
										background-color: #eb793c;
									}
								}
								+ .el-radio__label {
									//选中时字体的颜色
									color: #eb793c !important;
								}
							}
							.el-radio__inner {
								// 鼠标滑过小圆点时的样式
								&:hover {
									border-color: #eb793c;
								}
							}
						}
					}
				}
				&-item {
					display: flex;
					// align-items: center;
					justify-content: space-between;
					font-size: 14px;
					// height: 32px;
					div:nth-child(1) {
						color: #272c40;
						overflow: hidden;
						display: -webkit-box;
						text-overflow: ellipsis;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						white-space: normal;
						margin-right: 20px;
						text-align: left;
						line-height: 20px;
					}
					span:nth-child(2) {
						color: #eb793c;
						font-weight: 600;
					}
				}
			}
			.company-info-addition {
				margin: 12px 0 14px 0;
				display: flex;
				align-items: center;
				.price {
					margin-left: 10px;
					color: #eb793c;
					font-size: 14px;
				}
				.company-info-price-tag {
					&.free {
						color: rgb(27, 200, 188);
						font-size: 14px;
					}
					&.needPay {
						padding: 3px 8px;
						border-radius: 4px;
						color: #fff;
						font-size: 12px;
						background-color: #eb793c;
						margin-right: 7px;
					}
					&.price {
						margin-left: 10px;
						color: #eb793c;
						font-size: 16px;
						font-weight: 600;
					}
					&.origin-price {
						color: #999;
						font-size: 16px;
						font-weight: 400;
						margin-left: 10px;
						text-decoration-line: line-through;
					}
					&.paid {
						border: 1px solid #eb793c;
						color: #eb793c;
						font-weight: 600;
					}
				}
			}

			.company-info-detail-tagInfo {
				margin-top: 11%;
				.el-divider {
					margin: 24px auto;
					background-color: #ccc;
					width: 50%;
					height: 2px;
					border-radius: 3px;

					.el-divider__text {
						padding: 0 10px;
						width: fit-content;
						color: #999;
						font-size: 16px;
					}
				}
			}
			.company-info-detail-payWay {
				margin-bottom: 10px;
				.pay-tit {
					text-align: center;
					color: #272c40;
					font-weight: 600;
					font-size: 20px;
					margin: 40px 0;
				}
				.pay-con {
					display: flex;
					padding: 0 34px;
					justify-content: space-between;
					.pay-item {
						cursor: pointer;
						display: flex;
						width: 130px;
						height: 115px;
						background: #eaffea;
						border: 1px solid #09bb07;
						border-radius: 6px;
						justify-content: flex-end;
						align-items: center;
						flex-direction: column;
						padding-bottom: 18px;
						color: #333333;
						font-size: 16px;
						font-weight: 600;
						&:nth-child(2) {
							background: #f7faff;
							border: 1px solid #1677ff;
							.pay-icon {
								width: 50px;
								margin-bottom: 9px;
							}
						}
						.pay-icon {
							width: 43px;
							margin-bottom: 16px;
						}
					}
				}
				.pay-tip {
					color: #999999;
					font-size: 12px;
					padding: 0 20px;
					line-height: 20px;
					text-align: center;
					margin-top: 40px;
				}
			}
		}
		.company-info-detail {
			margin: 5% 0;
			padding: 5%;
			background-color: #f9f9f9;
			border-radius: 6px;
			color: #999;
			line-height: 2;
			font-size: 14px;

			.el-icon-user {
				margin-right: 10px;
			}

			label {
				color: #333;
			}
		}
		.pay-content {
			display: flex;
			align-items: center;
			flex-direction: column;
			.pay-tips {
				margin-top: 50px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #09bb07;
				font-size: 18px;
				img {
					padding-right: 10px;
				}
				&.ali {
					color: #1677ff;
				}
			}
			.company-image {
				width: 200px;
				height: 200px;
			}
			.more-pay-way {
				color: #8c8c8c;
				font-size: 16px;
				cursor: pointer;
				margin-top: 10px;
			}
		}
		.download-btn,
		.pay-btn {
			width: 100%;
			font-size: 20px;
			line-height: 1.5;
			position: relative;
			margin-left: 0;
			border-radius: 50px;
			&-img {
				margin-right: 4px;
				width: 26px;
				vertical-align: middle;
			}
			.service-modal {
				position: absolute;
				left: -400px;
				cursor: default;
				top: -37px;
				width: 470px;
				height: 180px;
				background: #fff;
				box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.302);
				border-radius: 4px 4px 4px 4px;
				padding: 15px 20px;
				overflow: hidden;
				display: flex;
				img {
					width: 150px;
					height: 150px;
					border-radius: 2px;
					margin-right: 15px;
				}
				& > div {
					flex: 1;
					// overflow: hidden;
					height: 150px;
					margin-top: 3px;
				}
				&-tit {
					color: #252525;
					font-size: 20px;
					font-weight: 600;
					text-align: left;
					margin-bottom: 12px;
				}
				&-info {
					color: #8c8c8c;
					font-size: 18px;
					line-height: 26px;
					white-space: normal;
					text-align: left;
				}
			}
		}
		.show-url-btn {
			width: 100%;
			font-size: 20px;
			line-height: 1.5;
			position: relative;
			background-color: #ffffff;
			border-color: #2F54EB;
			color: #2F54EB;
			margin-bottom: 15px;
			border-radius: 50px;
			&:hover {
				background: #E0EAFF;
				border: 1px solid #2F54EB;
			}
		}
		.ques-contract {
			display: flex;
			align-items: center;
			color: #252525;
			font-size: 12px;
			margin: 15px 0;
			.contract {
				color: #eb793c;
			}
			img {
				width: 18px;
				height: 18px;
				margin-right: 5px;
				cursor: pointer;
			}
		}
		.ques-text {
			color: #999999;
			line-height: 20px;
			font-size: 12px;
			margin-top: 20px;
		}
		.download-btn {
			&.is-disabled {
				font-size: 20px;
			}
		}
		.pay-btn {
			background-color: #2F54EB;
			border-color: #2F54EB;
			&:hover {
				background: #6583FF;
				border-color: #6583FF;
			}
		}
		.download-tip {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
			color: #aaa;
			font-size: 12px;
			/deep/ .el-icon-warning-outline {
				margin-left: 5px;
				transform: rotateX(180deg);
				font-size: 14px;
			}
		}
	}
}
</style>
